import { useState } from 'react';
import { Button } from '../../../core/components/atoms/Button';
import { useForm } from 'react-hook-form';
import { ICreatePassword } from '../models/user.model';
import { Input } from '../../../core/components/atoms/Input';
import { Alert } from '../../../core/components/atoms/Alert';
import { Typography } from '../../../core/components/molecules/Typography';
import { useCreatePassword } from '../hooks/useCreatePassword';
import { useParams } from 'react-router-dom';
import LogoMobile from '../../../assets/images/brand/logo-black.png';
import BackgroundRight from '../../../assets/images/login/bg-texture.png';

export default function CreatePassword() {
  const { token } = useParams();

  const [inputType, setInputType] = useState<string>('password');
  const [inputTypeConfirm, setInputTypeConfirm] = useState<string>('password');
  const { mutate, isError, error, isLoading, isSuccess } = useCreatePassword();

  const {
    getValues,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ICreatePassword>();

  const onSubmit = (data: ICreatePassword) => {
    const body = { password: data.password, token: token || '' };
    mutate(body);
  };

  return (
    <div className='md:center flex h-screen flex-col items-center justify-center md:flex-row'>
      <div className='bg-white w-full justify-center p-4 shadow-level-1 xs:flex md:hidden'>
        <img src={LogoMobile} alt='Imagem de Login' className='h-6' />
      </div>
      <div className='bg-primary-500 flex items-center justify-center xs:w-0 md:h-screen md:w-1/2 lg:w-[55%] xl:w-[60%]'>
        <div className='bg-white rounded-lg px-12 py-4 xs:hidden lg:block'>
          <img
            src={LogoMobile}
            alt='Imagem de Login'
            className='max-w-xs pb-12 md:pb-0'
          />
        </div>
      </div>
      <div className='flex h-screen flex-col items-center justify-center p-4 xs:w-full md:w-1/2 lg:w-[45%] xl:w-[40%]'>
        <img
          src={BackgroundRight}
          alt='Logo Aprova'
          className='absolute right-0 h-full xs:hidden md:block'
        />

        <div className='z-10 text-left xs:w-[90%] md:absolute md:right-[25%] md:w-[50%] lg:static lg:w-[75%] xl:w-[65%] 2xl:absolute 2xl:right-[32%] 2xl:w-[16%]'>
          {isSuccess ? (
            <div className='bg-white flex flex-col gap-xxxl rounded-lg p-8 shadow-level-4'>
              <Typography size='h2' type='title' weight='bold' className='mb-2'>
                Tudo pronto para começar
              </Typography>

              <Alert
                variant='success'
                title='Sua senha foi criada'
                message='Você já pode acessar a plataforma'
                className='mb-4'
              />

              <Button variant='contained' size='large' full asLink to='/login'>
                Acessar plataforma
              </Button>
            </div>
          ) : (
            <div className='bg-white rounded-lg p-8 shadow-level-4'>
              <Typography size='h2' type='title' weight='bold' className='mb-2'>
                Crie uma senha
              </Typography>
              <Typography size='default' className='text-mono-900 mb-12'>
                A senha deve conter ao menos 8 caracteres.
              </Typography>

              {isError && (
                <Alert
                  variant='error'
                  title='Erro ao criar'
                  message={
                    error?.toString() ||
                    'Houve algum problema ao criar sua senha'
                  }
                  className='mb-4'
                />
              )}

              <form onSubmit={handleSubmit(onSubmit)} className='text-left'>
                <div className='mb-4'>
                  <Input
                    {...register('password', {
                      required: true,
                      minLength: {
                        value: 8,
                        message: 'A senha digitada não contém 8 caracteres',
                      },
                    })}
                    label='Senha'
                    placeholder='Digite uma senha'
                    errorMessage={errors.password && errors.password.message}
                    type={inputType}
                    IconLeft={{
                      type: 'material',
                      Icon: 'lock',
                    }}
                    IconRight={{
                      type: 'material',
                      Icon:
                        inputType === 'password'
                          ? 'visibility_off'
                          : 'visibility',
                      className: 'cursor-pointer',
                      onClick: () => {
                        setInputType(
                          inputType === 'password' ? 'text' : 'password'
                        );
                      },
                    }}
                  />
                </div>
                <div className='mb-12'>
                  <Input
                    {...register('confirmPassword', {
                      required: true,
                      validate: (value) =>
                        value === getValues('password') ||
                        'As senhas digitadas são diferentes',
                    })}
                    label='Confirme a senha'
                    placeholder='Confirme a senha'
                    errorMessage={
                      errors.confirmPassword && errors.confirmPassword.message
                    }
                    type={inputTypeConfirm}
                    IconLeft={{
                      type: 'material',
                      Icon: 'lock',
                    }}
                    IconRight={{
                      type: 'material',
                      Icon:
                        inputTypeConfirm === 'password'
                          ? 'visibility_off'
                          : 'visibility',
                      className: 'cursor-pointer',
                      onClick: () => {
                        setInputTypeConfirm(
                          inputTypeConfirm === 'password' ? 'text' : 'password'
                        );
                      },
                    }}
                  />
                </div>

                <Button
                  variant='contained'
                  size='large'
                  full
                  loading={isLoading}
                >
                  Salvar senha
                </Button>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
